module.exports = __webpack_public_path__ + "static/media/img_error404.e3ca3306.png";